@if (lorenzFormGroup && lorenzFormControl) {

	<div class="outer-wrapper"
		 [formGroup]="lorenzFormGroup">

		<div class="control-wrapper">

			<div class="control"
				 [innerHTML]='computedValue'
				 [attr.title]="title() || null">
			</div>

			@if (isLayoutFloatingLabels && lorenzFormControl.hasLabel()) {
				<label class="floating-label"
					   [innerHTML]="(lorenzFormControl.getLabel() | translate) + lorenzFormControl.getRequiredAsterisk()">
				</label>
			}

		</div>

	</div>


	<lib-form-validity-dot [control]="lorenzFormControl" />

	@if (showErrorMessages) {
		<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
	}

}
